import LoginButton from './LoginButton';

export default function LoginRoute() {
  return (
    <LoginButton />
  )
}